import { render, staticRenderFns } from "./customerrelationselector.vue?vue&type=template&id=498b15de"
import script from "./customerrelationselector.vue?vue&type=script&lang=js"
export * from "./customerrelationselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports